import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
fragment msg on Message {
    id
    sender
    insertedAt
    body
    isRead
    customerId
    customerType
    operatorId
    activityId
    receiver
    to
    from
    copies
    auto
    avatarUrl
    attachments {
      title
      type
      size
      original
      preview
      ext
    }
}

query customerCasesPagination($customerId: Int!, $page: Int, $pageSize: Int, $opened: Boolean, $currentCase: Int ) {
  customerCasesPagination(customerId: $customerId, page: $page, pageSize: $pageSize, opened: $opened, currentCase: $currentCase) {
    totalCount
    pageSize
    totalCount
    totalActivitiesCount
    firstActivityDate
    customerCases{
      id
      insertedAt
      updatedAt
      status
      description
      comment
      messages {
        ...msg
      }
      activities {
        id
        channelType
        channelName
        insertedAt
        duration
        operator {
          id
          fullName
        }
        markers {
        id
        name
        directory {
          id
          name
        }
      }
        requestType {
          id
          name
        }
      }
    }
  }
}`;

function parse(item) {
  return {
    ...item,
    activities: item.activities.map((activity) => ({
      ...activity,
      type: activity.channelType,
      case: {
        id: item.id,
        description: item.description,
      },
    })),
  };
}

export default function getCustomerCasesPagination({
  customerId, page, pageSize, opened, currentCase,
}) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: {
      customerId: parseInt(customerId, 10),
      page,
      pageSize,
      opened,
      currentCase,
    },
  }).then((res) => ({
    totalCount: res.data.customerCasesPagination.totalCount,
    totalActivitiesCount: res.data.customerCasesPagination.totalActivitiesCount,
    pageSize: res.data.customerCasesPagination.pageSize,
    firstActivityDate: res.data.customerCasesPagination.firstActivityDate,
    customerCases: res.data.customerCasesPagination.customerCases.map(parse),
  }));
}
